import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { PermissionProvider } from 'contexts/PermissionContext';
import './global.css';
import { LoginLogsProvider } from 'contexts/LoginLogsContext';
import { EmailLogsProvider } from 'contexts/EmailLogsContext';
import { TenantProvider } from 'contexts/TenantContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <AuthProvider>
                <PermissionProvider>
                  <LoginLogsProvider>
                    <EmailLogsProvider>
                      <TenantProvider>
                        <>
                          <Notistack>
                            <RouterProvider router={router} />
                            <Snackbar />
                          </Notistack>
                        </>
                      </TenantProvider>
                    </EmailLogsProvider>
                  </LoginLogsProvider>
                </PermissionProvider>
              </AuthProvider>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </LocalizationProvider>
  );
}
